import { Trans } from 'react-i18next'

/**
 * @param {Object} props
 * @param {string} [props.translationKey]
 * @param {Object} [props.args]
 * @param {Array} [props.components]
 */
const TranslateHTML = ({ translationKey = '', args = {}, components = [] }) => (
  <Trans i18nKey={translationKey} values={args} components={components} />
)

export default TranslateHTML
